$(document).ready(function () {
    var cs_width = window.screen.width;

    /* if(cs_width > 767){
        AOS.init();
    } */

    AOS.init({ disable: 'mobile' })

    $('.main-slider.owl-carousel').owlCarousel({
        //loop:fasle,
        margin: 0,
        nav: false,
        dots: true,
        autoplay: true,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        mouseDrag: false,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 1
            },
            1000: {
                items: 1
            }
        }
    })

    $('.product-slider.owl-carousel').owlCarousel({
        loop: true,
        margin: 0,
        navText: ["<i class='fa fa-caret-left'></i>", "<i class='fa fa-caret-right'></i>"],
        nav: true,
        dots: false,
        autoplay: true,
        mouseDrag: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 4
            }
        }
    })

    $('.image-slider.owl-carousel').owlCarousel({
        loop: false,
        margin: 0,
        navText: ["<i class='fa fa-caret-left'></i>", "<i class='fa fa-caret-right'></i>"],
        nav: true,
        dots: false,
        autoplay: true,
        mouseDrag: true,
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    })


    $(".fancybox").fancybox({
        openEffect: "none",
        closeEffect: "none"
    });


    $('.header-mobile .xs-header-icon button').click(function (e) {
        e.preventDefault();
        $('.mobile-menu.navbar').slideToggle();
    });

   // $('.cs-modal-btn').click(function () {
      //  var url = $(this).data('video_url')
      //  var iframe = "<iframe src='" + url + "' class='cs-iframe'></iframe>"
       // $('#f_modal .cs-modal-body').html(iframe)
       // $('#f_modal').css('display', 'block')
       // $('body').css('overflow','hidden')
    //})


    $('.cs-booking-modal-btn').click(function () {
        $('#booking_modal').css('display', 'block')
        $('body').css('overflow','hidden')
    })

    $('.cs-close').click(function () {
        $('.cs-modal .cs-modal-body .cs-iframe').remove()
        $('.cs-modal').css('display', 'none')
        $('body').css('overflow','inherit')
    })
    
});
$(document).ready(function(){
    var pathname = window.location.href; 
    if(pathname == "https://milkshake-the-pug.myshopify.com/collections/all")
    {
        $(document).ready(function(){
        $(".by_de").attr("selected", "selected");
        });    
    }
});
$(function() {
  // bind change event to select
  $('#dynamic_select').on('change', function() {
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      window.location = url; // redirect
    }
    return false;
  });
});